import { rpost, rget, DEV_URL } from 'utils/requests';

export interface CompanyHierarchyUpdate {
    CompanyId: string;
    NewParentId: string | null;
    ActionType?: string | null;
}

export interface UpdateCompanyHierarchyPayload {
    Updates: CompanyHierarchyUpdate[];
}

/**
 * Update company hierarchy (add/update/remove parent or child)
 */
export const updateCompanyHierarchy = async (updates: CompanyHierarchyUpdate[]): Promise<any> => {
    const payload: UpdateCompanyHierarchyPayload = { Updates: updates };
    return await rpost(`${DEV_URL}/api/company/UpdateCompanyHierarchy`, payload);
};

/**
 * Get company hierarchy (parents, grandparents, children, grandchildren)
 */
export const getCompanyHierarchy = async (companyId: string): Promise<any> => {
    return await rget(`${DEV_URL}/api/company/GetCompanyHierarchy/${companyId}`);
};

/**
 * Get company hierarchy change logs
 */
export const getCompanyHierarchyLogs = async (companyId: string): Promise<any> => {
    return await rget(`${DEV_URL}/api/company/GetCompanyHierarchyLogs/${companyId}`);
};

